import { Icon } from '@mdvip/shared/components/blocks/Icon';
import { Button } from '@mdvip/shared/components/ui/button';
import { useTranslation } from 'react-i18next';
import type { DatasetState } from '@/hooks/member-views/useMemberDataset';

export interface GenerateReportButtonProps {
  state: DatasetState;
  /** How many rows the report would hold — every row matching the view and letter. */
  rowCount: number;
  pending: boolean;
  onGenerate: () => void;
}

/**
 * The directory toolbar's download: the current view's rows as a CSV report. Disabled while there's
 * nothing to report — loading, the error state, zero matching rows — or one is already being made.
 * Full width under the view select on a phone, its own width beside it from the container's 768px band.
 */
export function GenerateReportButton({ state, rowCount, pending, onGenerate }: GenerateReportButtonProps) {
  const { t } = useTranslation('providers');
  return (
    <Button
      className="h-11 flex-1 @3xl/md:flex-none"
      disabled={state !== 'loaded' || rowCount === 0 || pending}
      onClick={onGenerate}
    >
      <Icon name="fileArrowDown" size="sm" />
      {t('memberViews.toolbar.generateReport')}
    </Button>
  );
}
